import { asLazy } from 'shared/utils/lazy.utils.js';

export const ActionsPage = asLazy(
  import('./pages/ActionsPage/ActionsPage.js'),
  'ActionsPage',
);
export const CompaniesPage = asLazy(
  import('./pages/CompaniesPage/index.js'),
  'CompaniesPage',
);
export const CompanyViewPage = asLazy(
  import('./pages/CompanyViewPage/CompanyViewPage.js'),
  'CompanyViewPage',
);
export const RegistryAdminListPage = asLazy(
  import('./pages/RegistryAdminListPage/index.js'),
  'RegistryAdminListPage',
);
export const UsersPage = asLazy(
  import('./pages/UsersPage/index.js'),
  'UsersPage',
);
export const UserViewPage = asLazy(
  import('./pages/UserViewPage/index.js'),
  'UserViewPage',
);
